site.s5festaha = {
	init: function () {
		$('.elm_StudiesAtUnak #studiesAtUnak-0').click(function () {
			site.s5festaha.show($('.elm_StudiesAtNotes'));
		});
		$('.elm_StudiesAtUnak #studiesAtUnak-1').click(function () {
			site.s5festaha.hide($('.elm_StudiesAtNotes'));
		});

		$('#fieldset-s5FetahaApplicantPartner .dgElements > div').each(function () {
			if(!$(this).hasClass('elm_Partnerfullname')) {
				site.s5festaha.hide($(this));
			}
		});


		$('.elm_Partnerfullname #partnerfullname').on('input',function(e){
			if($('.elm_Partnerfullname #partnerfullname').val().length > 0) {
				$('#fieldset-s5FetahaApplicantPartner .dgElements > div').each(function () {
					if(!$(this).hasClass('elm_Partnerfullname')) {
						site.s5festaha.show($(this));
					}

				});
			}
			else {
				$('#fieldset-s5FetahaApplicantPartner .dgElements > div').each(function () {
					if(!$(this).hasClass('elm_Partnerfullname')) {
						site.s5festaha.hide($(this));
					}
				});
			}
		});
		site.s5festaha.translate();
	},

	translate: function() {
		$('.flags .icelandic').click(function () {
			//toogle Flags
			site.s5festaha.hide($('.flags .icelandic'));
			site.s5festaha.show($('.flags .english'));
			//toogle Title
			site.s5festaha.hide($('#festahaApplication .applicationTitleEn'));
			site.s5festaha.show($('#festahaApplication .applicationTitleIs'));
			//toogle Legend
			$( "#s5FestahaApplicationForm legend" ).each(function() {
				$( this ).text($( this ).parent().attr('data-translateIs'));
			});
			//toogle submit
			$( "#s5FestahaApplicationForm #submitApplication" ).each(function() {
				$( this ).attr('value',$( this ).attr('data-translateIs'));
			});
			//toogle Form
			$.datepicker.setDefaults( $.datepicker.regional[ "is" ] );
			$( "#s5FestahaApplicationForm .elm" ).each(function() {
				var label = $( this ).find('label.required');
				var input = $( this ).find('input');
				var select = $( this ).find('select');
				var textarea = $( this ).find('textarea');
				var desc = $( this ).find('.description');
				if($( this ).hasClass('elm_HousingNotes')
					|| $( this ).hasClass('elm_HousingPreviousApplication')
					|| $( this ).hasClass('elm_AddressWhereabouts')
					|| $( this ).hasClass('elm_Partnerfullname')
					|| $( this ).hasClass('elm_Partnerkennitala')
					|| $( this ).hasClass('elm_Partneraddress')
					|| $( this ).hasClass('elm_Partneremail')
					|| $( this ).hasClass('elm_PartnerStudiesAtUnak')
					|| $( this ).hasClass('elm_Partnerphone')) {
					label = $( this ).find('label.optional');
				}
				if(label[0] && input[0]) {
					label.text(input.attr('data-translateIs'));
				} else if (label[0] && select[0]) {
					label.text(select.attr('data-translateIs'));
				} else if (label[0] && textarea[0]) {
					label.text(textarea.attr('data-translateIs'));
				}
				if(desc[0] && input[0]) {
					desc.text(input.attr('data-descIs'))
				} else if(desc[0] && textarea[0]) {
					desc.text(textarea.attr('data-descIs'))
				}
			});
			$( "#s5FestahaApplicationForm .elm_Zip" ).each(function() {
				var select = $( this ).find('select');
				$( this ).find('option:first').text(select.attr('data-optionsIs'));
				$( this ).find('select option:first').attr('label',select.attr('data-optionsIs'));
			});
			$( "#s5FestahaApplicationForm .elm_NumberOfChildren" ).each(function() {
				var label = $( this ).find('.lmnt label:first-child');
				var input = label.find('input');
				label.text(input.attr('data-optionsIs'));
				label.prepend(input);
			});
			$( "#s5FestahaApplicationForm .eType_radio:not(.elm_NumberOfChildren):not(.elm_PartnerStudiesAtUnak)" ).each(function() {
				var label1 = $( this ).find('.lmnt label:first-child');
				var label2 = $( this ).find('.lmnt label:last-child');
				var input1 = label1.find('input');
				var input2 = label2.find('input');
				label1.text(input1.attr('data-options1Is'));
				label1.prepend(input1);
				label2.text(input2.attr('data-options2Is'));
				label2.prepend(input2);
			});
			$( "#s5FestahaApplicationForm .elm_PartnerStudiesAtUnak" ).each(function() {
				var label1 = $( this ).find('.lmnt label:first-child');
				var label2 = $( this ).find('.lmnt label:nth-of-type(2)');
				var label3 = $( this ).find('.lmnt label:last-child');
				var input1 = label1.find('input');
				var input2 = label2.find('input');
				var input3 = label3.find('input');
				label1.text(input1.attr('data-options1Is'));
				label1.prepend(input1);
				label2.text(input2.attr('data-options2Is'));
				label2.prepend(input2);
				label3.text(input3.attr('data-options3Is'));
				label3.prepend(input3);
			});
			$( "#s5FestahaApplicationForm .eType_select:not(.elm_Zip)" ).each(function() {
				var select = $( this ).find('select');
				var arr = select.attr('data-optionsIs').split(',');
				select.find('option').each(function(index) {
					$( this ).attr('label',arr[index]);
				})
			});
		});
		$('.flags .english').click(function () {
			//toogle Flags
			site.s5festaha.show($('.flags .icelandic'));
			site.s5festaha.hide($('.flags .english'));
			//toogle Title
			site.s5festaha.show($('#festahaApplication .applicationTitleEn'));
			site.s5festaha.hide($('#festahaApplication .applicationTitleIs'));
			$( "#s5FestahaApplicationForm legend" ).each(function() {
				$( this ).text($( this ).parent().attr('data-translateEn'));
			});
			//toogle submit
			$( "#s5FestahaApplicationForm #submitApplication" ).each(function() {
				$( this ).attr('value',$( this ).attr('data-translateEn'));
			});
			//toogle Form
			$.datepicker.setDefaults( $.datepicker.regional[ "" ] );
			$( "#s5FestahaApplicationForm .elm" ).each(function() {
				var label = $( this ).find('label.required');
				var input = $( this ).find('input');
				var select = $( this ).find('select');
				var textarea = $( this ).find('textarea');
				if($( this ).hasClass('elm_HousingNotes')
					|| $( this ).hasClass('elm_HousingPreviousApplication')
					|| $( this ).hasClass('elm_AddressWhereabouts')
					|| $( this ).hasClass('elm_Partnerfullname')
					|| $( this ).hasClass('elm_Partnerkennitala')
					|| $( this ).hasClass('elm_Partneraddress')
					|| $( this ).hasClass('elm_Partneremail')
					|| $( this ).hasClass('elm_PartnerStudiesAtUnak')
					|| $( this ).hasClass('elm_Partnerphone')) {
					label = $( this ).find('label.optional');
				}
				var desc = $( this ).find('.description');
				if(label[0] && input[0]) {
					label.text(input.attr('data-translateEn'));
				} else if (label[0] && select[0]) {
					label.text(select.attr('data-translateEn'));
				} else if (label[0] && textarea[0]) {
					label.text(textarea.attr('data-translateEn'));
				}
				if(desc[0] && input[0]) {
					desc.text(input.attr('data-descEn'))
				} else if(desc[0] && textarea[0]) {
					desc.text(textarea.attr('data-descEn'))
				}
			});
			$( "#s5FestahaApplicationForm .elm_Zip" ).each(function() {
				var select = $( this ).find('select');
				$( this ).find('select option:first').attr('label',select.attr('data-optionsEn'));
			});
			$( "#s5FestahaApplicationForm .elm_NumberOfChildren" ).each(function() {
				var label = $( this ).find('.lmnt label:first-child');
				var input = label.find('input');
				label.text(input.attr('data-optionsEn'));
				label.prepend(input);
			});
			$( "#s5FestahaApplicationForm .eType_radio:not(.elm_NumberOfChildren):not(.elm_PartnerStudiesAtUnak)" ).each(function() {
				var label1 = $( this ).find('.lmnt label:first-child');
				var label2 = $( this ).find('.lmnt label:last-child');
				var input1 = label1.find('input');
				var input2 = label2.find('input');
				label1.text(input1.attr('data-options1En'));
				label1.prepend(input1);
				label2.text(input2.attr('data-options2En'));
				label2.prepend(input2);
			});
			$( "#s5FestahaApplicationForm .elm_PartnerStudiesAtUnak" ).each(function() {
				var label1 = $( this ).find('.lmnt label:first-child');
				var label2 = $( this ).find('.lmnt label:nth-of-type(2)');
				var label3 = $( this ).find('.lmnt label:last-child');
				var input1 = label1.find('input');
				var input2 = label2.find('input');
				var input3 = label3.find('input');
				label1.text(input1.attr('data-options1En'));
				label1.prepend(input1);
				label2.text(input2.attr('data-options2En'));
				label2.prepend(input2);
				label3.text(input3.attr('data-options3En'));
				label3.prepend(input3);
			});
			$( "#s5FestahaApplicationForm .eType_select:not(.elm_Zip)" ).each(function() {
				var select = $( this ).find('select');
				var arr = select.attr('data-optionsEn').split(',');
				select.find('option').each(function(index) {
					$( this ).attr('label',arr[index]);
				})
			});
		});
	},

	translateTerms: function() {
		var textEn = document.getElementById('termsInput').getAttribute('data-translateEn');
		var textIS = document.getElementById('termsInput').getAttribute('value');
		$('.flags .icelandic').click(function () {
			//toogle Flags
			site.s5festaha.hide($('.flags .icelandic'));
			site.s5festaha.show($('.flags .english'));
			//toogle Terms
			site.s5festaha.hide($('#festahaTerms .termsEn'));
			site.s5festaha.show($('#festahaTerms .termsIs'));
			//toogle Title
			site.s5festaha.hide($('#festahaTerms .termsTitleEn'));
			site.s5festaha.show($('#festahaTerms .termsTitleIs'));
			//toogle Input
			document.getElementById('termsInput').value = textIS;
		});
		$('.flags .english').click(function () {
			site.s5festaha.show($('.flags .icelandic'));
			site.s5festaha.hide($('.flags .english'));
			//toogle Terms
			site.s5festaha.hide($('#festahaTerms .termsIs'));
			site.s5festaha.show($('#festahaTerms .termsEn'));
			//toogle Title
			site.s5festaha.hide($('#festahaTerms .termsTitleIs'));
			site.s5festaha.show($('#festahaTerms .termsTitleEn'));
			//toogle Input
			document.getElementById('termsInput').value = textEn;
		});
	},

	show: function (selector) {
		$(selector).each(function () {
			$(this).css('display', 'block');
			$(this).css('opacity', '1');
		});
	},

	hide: function (selector) {
		$(selector).each(function () {
			$(this).css('display', 'none');
			$(this).css('opacity', '0');
		});
	}
};